var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWorksection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "#929497",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.652 5.862c-.666.64-2.164.725-2.318.86-.175.149-.225.428-.225 1.203v4.265C12.105 14.289 10.523 16 8.587 16h-.195a3.4 3.4 0 01-2.335-.964C5.415 15.65 4.57 16 3.72 16h-.195C1.586 16 .004 14.289 0 12.19V5.628c0-.707.533-1.284 1.186-1.284.654 0 1.187.577 1.187 1.284v6.562c.004.675.528 1.243 1.153 1.247h.195c.62 0 1.15-.572 1.15-1.247V9.41c0-.706.532-1.283 1.186-1.283.653 0 1.186.577 1.186 1.284v2.774c0 .676.529 1.243 1.149 1.248h.191c.62 0 1.145-.572 1.15-1.248v-7.21c0-1.63.524-3.022 1.448-3.95C12.467-.26 15.223-.223 15.75.507c.55.748.192 4.112-1.099 5.355z"
  })));
}

export default SvgWorksection;